import { render, staticRenderFns } from "./ToeflPrimaryStep1TimeManagerComponent.vue?vue&type=template&id=2319a5d3&scoped=true&"
import script from "./ToeflPrimaryStep1TimeManagerComponent.vue?vue&type=script&lang=js&"
export * from "./ToeflPrimaryStep1TimeManagerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToeflPrimaryStep1TimeManagerComponent.vue?vue&type=style&index=0&id=2319a5d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2319a5d3",
  null
  
)

export default component.exports